import { createSlice } from "@reduxjs/toolkit";

const initialOldState = {
    oldMode: null,
    oldId: null,
    oldPercentuage: null,
    oldData: null, // Aggiungiamo anche i dati della modale precedente
}

const initialState = {
    isOpen: false,
    mode: null,
    id: null,
    data: null, // Aggiungiamo il campo data per memorizzare dati aggiuntivi
    lastClosedData: null, // Dati dell'ultima modale chiusa, persistono per essere letti dopo la chiusura
    percentuageWidth: 95,
    oldState: initialOldState,
    goingToClose: { // Questo serve a chiudere RightModal da un altro componente che non sia RightModal (e refreshare i dati)
        isToClose: false,
        isToRefresh: false
    },
    isRefreshNow: false // Quando attivo la refresh viene eseguita
}

const rightModalSlice = createSlice({
    name: 'rightModal',
    initialState,
    reducers: {
        setModal: (state, action) => {
            const { id, mode, percentuageWidth, data } = action.payload;
            state.isOpen = true;
            state.id = id || null;
            state.mode = mode || null;
            state.data = data || null; // Salviamo i dati aggiuntivi
            state.percentuageWidth = percentuageWidth || 95;
        },
        closeModal: (state) => {
            // Salva i dati prima di resettare, così possono essere letti dopo la chiusura
            state.lastClosedData = state.data;
            
            // L'unico dato che riceva closeModal è il booleano di refresh dei dati della pagina principale
            if (state.goingToClose.isToRefresh) state.isRefreshNow = true;
            state.goingToClose = {
                isToClose: false,
                isToRefresh: false
            }
            state.isOpen = false;
            state.mode = null;
            state.id = null;
            state.data = null; // Reset anche del campo data
            state.percentuageWidth = 95;
            state.oldState = initialOldState;
        },
        setSwap: (state, action) => {
            const { id, mode, percentuageWidth, isOld, data, dataToSave } = action.payload;
            // Se isOld è impostato su true, metto in memoria il vecchio stato
            // In modo da poter gestire un tasto "torna indietro" nel contenuto successivo
            if (isOld) {
                state.oldState = {
                    oldMode: state.mode,
                    oldId: state.id,
                    oldPercentuage: state.percentuageWidth,
                    // Se dataToSave è fornito, usalo; altrimenti usa state.data
                    oldData: dataToSave || state.data // ✅ Permette di salvare dati personalizzati
                }
            } else {
                state.oldState = initialOldState
            }
            state.mode = mode;
            state.id = id;
            state.data = data || null; // Aggiungiamo la gestione del campo data
            state.percentuageWidth = percentuageWidth ?? 95;
        },
        setGoingToClose: (state) => {
            // Questo reducer imposta isToClose true (il quale viene sentito da RightModal che
            // esegue l'animazione di chiusura prima di chiudersi)
            // Opzionalmente setta isToRefresh true, il quale viene sentito dalla pagina principale
            // Che refresha i dati
            state.goingToClose.isToClose = true
        },
        setHasToRefresh: (state) => {
            // Questo reducer imposta isToClose true (il quale viene sentito dalla pagina principale
            // Che refresha i dati
            state.goingToClose.isToRefresh = true
        },
        resetRefreshNow: (state) => {
            // Questo viene sempre resettato dopo una fetch
            state.isRefreshNow = false
        },
        clearLastClosedData: (state) => {
            // Reset dei dati dell'ultima modale chiusa dopo che sono stati consumati
            state.lastClosedData = null
        },
        swapModal: (state, action) => {
            // Torna alla modale precedente usando oldState
            if (state.oldState.oldMode) {
                state.mode = state.oldState.oldMode;
                state.id = state.oldState.oldId;
                state.percentuageWidth = state.oldState.oldPercentuage || 95;
                
                // Ripristina i dati salvati, unendoli con eventuali dati aggiuntivi passati
                const additionalData = action.payload || {};
                state.data = {
                    ...state.oldState.oldData, // Dati salvati
                    ...additionalData // Dati aggiuntivi passati (es. nuovo indirizzo)
                };
                
                // Imposta anche lastClosedData per il refresh
                if (Object.keys(additionalData).length > 0) {
                    state.lastClosedData = additionalData;
                }
                
                // Reset oldState dopo averlo usato
                state.oldState = initialOldState;
            } else {
                console.warn('⚠️ swapModal: nessuno stato precedente disponibile');
            }
        }
    }
})

// Selector
export const selectRightModalIsOpen = (state) => state.rightModal.isOpen;
export const selectRightModalmode = (state) => state.rightModal.mode;
export const selectRightModalId = (state) => state.rightModal.id;
export const selectRightModalData = (state) => state.rightModal.data;
export const selectRightModalLastClosedData = (state) => state.rightModal.lastClosedData;
export const selectRightModalpercentuageWidth = (state) => state.rightModal.percentuageWidth;
export const selectRightModalOldState = (state) => state.rightModal.oldState;
export const selectRightModalGoingtoClose = (state) => state.rightModal.goingToClose;
export const selectRightModalIsRefreshNow = (state) => state.rightModal.isRefreshNow;
export const { setModal, closeModal, setSwap, swapModal, setGoingToClose, setHasToRefresh, resetRefreshNow, clearLastClosedData } = rightModalSlice.actions;
export default rightModalSlice.reducer;